export class SortDefinition {
    column: string;
    direction: 'asc' | 'desc' = 'asc';

    constructor(sort?: any) {
        if (sort != null) {
            this.column = sort.column;
            if (sort.direction != null) {
                this.direction = sort.direction;
            }
        }
    }
}